let selected_Variants = [];
const mainPro_VariantId = $('.product-variant-id').val();

updateCount(1);
toggleAddtoCart();
$(document).on('change', 'select[name="quantity"]', function() {
   const mainPro_Quantity = $(this).val();
  updateCount(parseInt(mainPro_Quantity) + selected_Variants.length);
});
$(document).on('change', 'input[name="bundle_pair"]', function () {
    const var_Id = $(this).val();

    if ($(this).is(':checked')) {
        selected_Variants.push(var_Id);
    } else {
        selected_Variants = selected_Variants.filter(id => id !== var_Id);
    }

  updateCount(parseInt($('select[name="quantity"]').val()) + selected_Variants.length);
  toggleAddtoCart();
});

function updateCount(count) {
    $('.count_product').text(count);
}
function toggleAddtoCart(){
  if(selected_Variants.length >0){
    $('.add_to_cartt').show();
  }else{
   $('.add_to_cartt').hide(); 
  }
}
$(document).on('click', '.add_to_cartt', function (e) {
    e.preventDefault();
    const mainPro_Quantity = $('select[name="quantity"]').val();
  //alert(mainPro_Quantity)
    const items = [{ id: mainPro_VariantId, quantity: mainPro_Quantity }];
    selected_Variants.forEach(var_Id => {
        items.push({ id: var_Id, quantity: 1 });
    });
  
    $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        success: function(cartItem){
          
          var cart_type = $('#cart_type').val();
          if(cart_type == 'drawer'){
            jQuery.getJSON('/cart.js', function(cart) {
                  $(".cart-count-bubble span").html(cart.item_count);                   
                });
            setTimeout(() => {
            $(document).on("click", "#CartDrawer-Overlay", function () {
                  $(".drawer__close").click();
             });
              }, 800); 
            
            $('cart-drawer').load(window.location.href + ' #CartDrawer');
            $('cart-drawer').removeClass('is-empty');
            $('cart-drawer').addClass('active');
          }else if(cart_type == 'page'){
            window.location.href = '/cart';
          }else if(cart_type == 'notification'){
            jQuery.getJSON('/cart.js', function(cart) {
                  $(".cart-count-bubble span").html(cart.item_count);                   
                });
           const cartNotification = document.querySelector('cart-notification');
             if (cartNotification) {
              $('#cart-notification').addClass('active');
  
              cartNotification.open();
              } else {
                console.error('CartNotification element not found.');
              }
          }
            
        },
        error: function (error) {
            console.error('Error adding items to cart:', error);
        }
    });
});
